var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "heading-elements text-white",
      attrs: { "data-action": "close" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.closeHelpBox.apply(null, arguments)
        },
      },
    },
    [_c("i", { staticClass: "feather icon-x" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }